const today = new Date();

// The online FEBRACE happens in January
export const isEventOnline = (today.getMonth() === 0);
